'use client';

import cx from 'classix';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { TbHomeSearch, TbUserSearch } from "react-icons/tb";

import SearchSlider from '@/features/global-search-banner/components/search-slider/search-slider';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import Footer from '@/layout/footer/footer';
import stylesHeader from '@/layout/header/header.module.scss';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import Button from '@/ui/button/button';

import styles from './not-found.module.scss';
import {useParams} from "next/navigation";
import {LISTING_URL_PART_VARIANTS} from "@/features/listing/constants/listing-constants";
import type {ListingUrl} from "@/features/listing/types/listing-types";

export default function NotFound() {
  const translationsActions = useTranslations('global.actions');
  const notFoundListingsPageTranslations = useTranslations('page.not-found.listings');
  const params = useParams();

  const listingTypeUrl = params.listingType;
  const listingType = LISTING_URL_PART_VARIANTS[listingTypeUrl as ListingUrl];

  const isUserLogged = !!getUserBearerCookie();

  const [showServiceType,
    setShowServiceType] = useState<boolean>(false);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  return (
    <>
      <header className={stylesHeader.header}>
        <div className={stylesHeader.main}>
          <button
            className={stylesHeader.logo}
            onClick={scrollToTop}
          >
            <Image
              src="/images/roomster-logo/logo.svg"
              width={38}
              height={38}
              alt="roomster logo"
            />
          </button>

          {!isUserLogged && (
            <div className={cx(stylesHeader.login, stylesHeader.login__errorPage)}>
              <Button href={ROUTER_LINKS.phoneAuth} element="link" variant="outlined" size="lg" fullWidth>
                {translationsActions('login')}
              </Button>
            </div>
          )}
        </div>
      </header>

      <div className={stylesHeader.header_margin} />

      <main className={styles.notFoundPage}>
        {listingType === 'haveapartment' || listingType === 'haveshare' ? (
          <TbHomeSearch className={styles.notFoundPage_icon} />
        ) : (
          <TbUserSearch className={styles.notFoundPage_icon} />
        )}

        <h1 className={styles.notFoundPage_description}>
          {notFoundListingsPageTranslations(`listing-type.${listingType}`)}
        </h1>

        <p className={styles.notFoundPage_description}>
          {notFoundListingsPageTranslations('use-search')}
        </p>

        <div className={styles.notFoundPage_search}>
          <SearchSlider
            showServiceType={showServiceType}
            setShowServiceType={setShowServiceType}
            place={null}
            lastSearchedPlaces={null}
          />
        </div>
      </main>

      <Footer />
    </>
  );
}
